export default __webpack_public_path__ + "static/media/hair-7-1.c78324a4.svg";